import { Component, OnInit } from '@angular/core';
import { UserService } from '@app/core/user.service';
import { Title } from '@angular/platform-browser';
import { tap } from 'rxjs/operators';
import { User } from '@models/user';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public quote: string | undefined;
  public isLoading = false;
  public user: User;

  constructor(private userService: UserService, private titleService: Title) {}

  ngOnInit() {
    this.userService
      .getUserInfo()
      .pipe(tap((user: any) => (this.user = user as User)))
      .subscribe();
    //Cambiar título de página tras el login
    if (this.titleService.getTitle() !== 'TBAGROSENSOR') {
      this.titleService.setTitle('TBAGROSENSOR');
    }
  }
}
